import {
  Box,
  Typography,
  Paper,
  Container,
  Stack,
  Button,
} from "@mui/material";
import BuildIcon from "@mui/icons-material/Build";
import RefreshIcon from "@mui/icons-material/Refresh";

export default function Mantenimiento() {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <Box
      sx={{
        bgcolor: "#fafafa",
        minHeight: "85vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={0}
          sx={{
            p: 5,
            borderRadius: 4,
            textAlign: "center",
            background: "#1975d1",
            color: "white",
          }}
        >
          <Stack spacing={3} alignItems="center">
            {/* Icono */}
            <Box
              sx={{
                bgcolor: "rgba(255,255,255,0.2)",
                p: 2,
                borderRadius: 3,
                display: "flex",
              }}
            >
              <BuildIcon sx={{ fontSize: 50 }} />
            </Box>

            {/* Título */}
            <Typography variant="h4" fontWeight={700}>
              En mantenimiento
            </Typography>

            {/* Descripción */}
            <Typography
              variant="body1"
              sx={{ opacity: 0.9, maxWidth: 400 }}
            >
              Estamos realizando mejoras en este módulo. 
              Vuelve a intentarlo en unos minutos.
            </Typography>
          </Stack>
        </Paper>

        {/* Footer mínimo */}
        <Typography
          variant="caption"
          display="block"
          textAlign="center"
          sx={{ mt: 3, color: "text.secondary" }}
        >
          Si el problema persiste, contacta al administrador del sistema.
        </Typography>
      </Container>
    </Box>
  );
}